import { render, staticRenderFns } from "./s_biosup.vue?vue&type=template&id=bd125166"
import script from "./s_biosup.vue?vue&type=script&lang=js"
export * from "./s_biosup.vue?vue&type=script&lang=js"
import style0 from "./s_biosup.vue?vue&type=style&index=0&id=bd125166&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports